import styled from 'styled-components';
import { Base } from 'styled';

export const Button = styled(Base)`
  margin-right: 0.25rem;
`;

export const Svg = styled(Base)`
  width: ${({ theme }) => theme.sizes.socialShareIcon};
  height: ${({ theme }) => theme.sizes.socialShareIcon};
`;
